export default __webpack_public_path__ + "static/media/banner-inner3.5ad57b15.jpg";